import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AccessIndex from '@/views/access/index.vue'
import AccessPermissions from '@/views/access/permissions.vue'
import AccessRoles from '@/views/access/roles.vue'

const accessRoutes: RouteRecordRaw[] = [
  {
    path: '/access',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'Access', component: AccessIndex },
      { path: 'roles', name: 'Access-Roles', component: AccessRoles },
      { path: 'permissions', name: 'Access-Permissions', component: AccessPermissions },
    ],
  },
]

export default accessRoutes
